module.exports = __webpack_public_path__ + "static/media/staedtler.d335ea55.png";